(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var body = document.body;
  var recsIndex = 0;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('cart-drawer-open');
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('cart-drawer-open');
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeDrawer();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-drawer-toggle]');
    if (opener) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-overlay]')) {
      closeDrawer();
    }
  });

  var SECTION_IDS = ['cart-drawer', 'header'];
  var isBusy = false;

  function setLoading(loading) {
    isBusy = loading;
    drawer.classList.toggle('is-loading', loading);
    drawer.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function renderSections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var newDrawer = doc.getElementById('CartDrawer');
      if (newDrawer) {
        var terms = drawer.querySelector('[data-cart-terms]');
        var termsChecked = terms ? terms.checked : false;
        drawer.innerHTML = newDrawer.innerHTML;
        var newTerms = drawer.querySelector('[data-cart-terms]');
        if (newTerms && termsChecked) {
          newTerms.checked = true;
          var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
          if (checkoutBtn) checkoutBtn.removeAttribute('aria-disabled');
        }
        recsIndex = 0;
      }
    }
    if (sections['header']) {
      var doc2 = parser.parseFromString(sections['header'], 'text/html');
      var freshCount = doc2.querySelector('[data-cart-count]');
      var freshTotal = doc2.querySelector('[data-cart-total]');
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        if (freshCount) el.textContent = freshCount.textContent;
      });
      document.querySelectorAll('[data-cart-total]').forEach(function (el) {
        if (freshTotal) el.textContent = freshTotal.textContent;
      });
    }
  }

  function refreshSections() {
    return fetch(window.location.pathname + '?sections=' + SECTION_IDS.join(','))
      .then(function (res) { return res.json(); })
      .then(renderSections);
  }

  function cartRequest(url, payload) {
    var isForm = payload instanceof FormData;
    if (isForm) {
      payload.append('sections', SECTION_IDS.join(','));
      payload.append('sections_url', window.location.pathname);
    } else {
      payload.sections = SECTION_IDS;
      payload.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? payload : JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (data.sections) return renderSections(data.sections);
        return refreshSections();
      });
  }

  function setBusy(el, busy) {
    if (!el) return;
    el.disabled = busy;
  }

  // The Orichi apps stamp product forms with properties[_current_time] on submit. A unique
  // line property stops Shopify merging repeat adds into one line, so our adds drop it and
  // refresh the attributes[_current_time] cart attribute Orichi uses for cart discounts instead.
  function cartFormData(form) {
    var data = new FormData(form);
    data.delete('properties[_current_time]');
    data.delete('attributes[_current_time]');
    return data;
  }

  function touchCurrentTime() {
    if (typeof window.updateCurrentTimeInputs !== 'function') return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _current_time: new Date().toISOString() } })
    }).catch(function (err) {
      console.error('Could not update _current_time', err);
    });
  }

  function addToCart(payload, triggerEl) {
    setBusy(triggerEl, true);
    return touchCurrentTime()
      .then(function () { return cartRequest('/cart/add.js', payload); })
      .then(function () { openDrawer(); })
      .catch(function (err) {
        console.error('Add to cart failed', err);
      })
      .finally(function () {
        setBusy(triggerEl, false);
      });
  }

  // Ribbon add-on: the bag line carries _ribbon_link and the ribbon line carries
  // _ribbon_for with the same token, so the ribbon quantity can follow the bag.
  // The token is derived from the variant and its visible properties, so adding the
  // same bag again produces identical lines and Shopify increases their quantity.
  function hashString(value) {
    var hash = 5381;
    for (var i = 0; i < value.length; i++) hash = ((hash << 5) + hash + value.charCodeAt(i)) >>> 0;
    return hash.toString(36);
  }

  function ribbonPayload(form) {
    var toggle = form.querySelector('[data-ribbon-variant-id]');
    if (!toggle || !toggle.checked) return null;
    var data = cartFormData(form);
    var quantity = parseInt(data.get('quantity'), 10) || 1;
    var properties = {};
    data.forEach(function (value, name) {
      var match = name.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    var signature = Object.keys(properties).sort().map(function (key) { return key + '=' + properties[key]; }).join('|');
    var token = data.get('id') + '-' + hashString(signature);
    properties._ribbon_link = token;
    var bag = { id: Number(data.get('id')), quantity: quantity, properties: properties };
    if (data.get('selling_plan')) bag.selling_plan = data.get('selling_plan');
    // Shopify lists the last-added line first, so the ribbon goes first to sit under its bag.
    return {
      items: [
        { id: Number(toggle.getAttribute('data-ribbon-variant-id')), quantity: quantity, properties: { For: toggle.getAttribute('data-ribbon-title'), _ribbon_for: token } },
        bag
      ]
    };
  }

  function syncRibbons() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var bagQty = {};
        cart.items.forEach(function (item) {
          var link = item.properties && item.properties._ribbon_link;
          if (link) bagQty[link] = (bagQty[link] || 0) + item.quantity;
        });
        var updates = {};
        var changed = false;
        cart.items.forEach(function (item) {
          var link = item.properties && item.properties._ribbon_for;
          if (!link) return;
          var qty = bagQty[link] || 0;
          if (qty !== item.quantity) {
            updates[item.key] = qty;
            changed = true;
          }
        });
        if (!changed) return false;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (res) {
          if (!res.ok) throw new Error('Ribbon sync failed');
          return true;
        });
      });
  }

  // Shared with the cart page section so its AJAX updates refresh the drawer and header too.
  window.KoiCart = {
    sectionIds: SECTION_IDS,
    renderSections: renderSections,
    syncRibbons: syncRibbons
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(ribbonPayload(form) || cartFormData(form), form.querySelector('[type="submit"]'));
  });

  // Shopify's payment buttons can't carry a second line, so while the ribbon is on a
  // transparent overlay covers them: clicking adds bag + ribbon to the cart and goes to checkout.
  function toggleBuyNow(toggle) {
    var form = toggle.form;
    var buyNow = form && form.querySelector('[data-ribbon-buy-now]');
    var buttons = form && form.querySelector('[data-dynamic-checkout-buttons]');
    if (!buyNow || !buttons) return;
    buyNow.hidden = !toggle.checked;
    buttons.inert = toggle.checked;
  }

  document.querySelectorAll('[data-ribbon-variant-id]').forEach(toggleBuyNow);

  // Shopify's payment buttons skip native form validation, so required fields
  // (such as Personalised Text) are checked before their click handlers run.
  document.addEventListener('click', function (e) {
    var buttons = e.target.closest('[data-dynamic-checkout-buttons]');
    var form = buttons && buttons.closest('form');
    if (!form || form.checkValidity()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    form.reportValidity();
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-ribbon-variant-id]')) toggleBuyNow(e.target);
  });

  document.addEventListener('click', function (e) {
    var buyNow = e.target.closest('[data-ribbon-buy-now]');
    if (!buyNow) return;
    e.preventDefault();
    var form = buyNow.form;
    var addButton = form.querySelector('[data-add-button]');
    var payload = ribbonPayload(form);
    if (!payload || (addButton && addButton.disabled)) return;
    if (!form.reportValidity()) return;
    var dynamic = buyNow.closest('[data-dynamic-checkout]');
    setBusy(buyNow, true);
    dynamic.classList.add('is-busy');
    touchCurrentTime()
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          window.location.href = '/checkout';
        });
      })
      .catch(function (err) {
        console.error('Buy it now failed', err);
        setBusy(buyNow, false);
        dynamic.classList.remove('is-busy');
      });
  });

  // Cart page: keep ribbon quantity inputs in step with their bag before "Update bag" or "Checkout".
  document.addEventListener('input', function (e) {
    var link = e.target.getAttribute('data-ribbon-link');
    if (!link) return;
    document.querySelectorAll('[data-ribbon-for="' + link + '"]').forEach(function (input) {
      input.value = e.target.value;
    });
  });

  if (document.querySelector('[data-cart-page]')) {
    syncRibbons()
      .then(function (changed) { if (changed) window.location.reload(); })
      .catch(function (err) { console.error(err); });
  }

  document.addEventListener('click', function (e) {
    var recBtn = e.target.closest('[data-rec-add]');
    if (recBtn) {
      e.preventDefault();
      addToCart({ id: recBtn.getAttribute('data-variant-id'), quantity: 1 }, recBtn);
    }
  });

  function showLineError(key, message) {
    var itemEl = drawer.querySelector('[data-cart-item][data-key="' + key + '"]');
    if (!itemEl || !message) return;
    var error = document.createElement('p');
    error.className = 'cart-drawer__error';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    itemEl.appendChild(error);
  }

  document.addEventListener('click', function (e) {
    var decrease = e.target.closest('[data-quantity-decrease]');
    var increase = e.target.closest('[data-quantity-increase]');
    var remove = e.target.closest('[data-cart-remove]');
    if (!decrease && !increase && !remove) return;

    var itemEl = e.target.closest('[data-cart-item]');
    if (!itemEl) return;
    e.preventDefault();
    if (isBusy) return;

    var key = itemEl.getAttribute('data-key');
    var qty = parseInt(itemEl.getAttribute('data-quantity'), 10) || 0;
    var newQty = qty;
    if (increase) newQty = qty + 1;
    if (decrease) newQty = Math.max(0, qty - 1);
    if (remove) newQty = 0;
    if (newQty === qty) return;

    var valueEl = itemEl.querySelector('[data-quantity-value]');
    if (valueEl) valueEl.textContent = newQty;
    setLoading(true);

    cartRequest('/cart/change.js', { id: key, quantity: newQty })
      .then(syncRibbons)
      .then(function (changed) { if (changed) return refreshSections(); })
      .catch(function (err) {
        console.error('Cart update failed', err);
        return refreshSections().then(function () {
          showLineError(key, (err && (err.description || err.message)) || 'Sorry, we couldn\'t update your cart. Please try again.');
        });
      })
      .finally(function () {
        setLoading(false);
      });
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-terms]')) {
      var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
      if (checkoutBtn) {
        if (e.target.checked) {
          checkoutBtn.removeAttribute('aria-disabled');
        } else {
          checkoutBtn.setAttribute('aria-disabled', 'true');
        }
      }
    }
  });

  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('[data-cart-checkout]');
    if (checkoutBtn && checkoutBtn.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
    }
  });

  function getRecsPerView() {
    return window.innerWidth < 550 ? 2 : 2;
  }

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-recs-prev]');
    var next = e.target.closest('[data-recs-next]');
    if (!prev && !next) return;

    var wrap = (prev || next).closest('.cart-drawer__recs-wrap');
    var track = wrap.querySelector('[data-recs-track]');
    var items = track.querySelectorAll('.cart-drawer__rec');
    var perView = getRecsPerView();
    var maxIndex = Math.max(0, items.length - perView);

    if (next) recsIndex = Math.min(maxIndex, recsIndex + perView);
    if (prev) recsIndex = Math.max(0, recsIndex - perView);

    var itemWidth = items.length ? items[0].getBoundingClientRect().width + 14.4 : 0;
    track.style.transform = 'translateX(-' + (recsIndex * itemWidth) + 'px)';
  });
})();
